import {combineReducers} from 'redux';
import AuthReducer from './auth';
import BrandingDataReducer from './branding';

export default combineReducers({
  appConfigData: AuthReducer,
  brandingData: BrandingDataReducer,
});
